<div class="timeline-header">
  <div class="block-header">
    Timeline
  </div>

  <button mat-button matTooltip="New" (click)="createNote.emit()" [disabled]="disabled()">
    <mat-icon svgIcon="plus" />
    Create note
  </button>
</div>



<div class="timeline-list">
  @if (!timelineRecords().length) {
    <span class="warning">No Record found</span>
  }

  @for (timeline of timelineRecords(); track $index) {
    <app-timeline-record 
      class="timeline" 
      [timeline]="timeline" 
      [haveAccess]="haveAccess() && timeline.type === TimelineItemType.Note"
      (download)="download.emit($event)" 
      (delete)="onDelete(timeline)" 
      (edit)="editNote.emit($index)" 
    />
  }
</div>
